import React from "react";

import { ImageSize, imgSrc } from "src/components/PlmUploader/imgSrc";
import { Tag } from "antd";
import { ImgListDetails } from "./ImgListDetails";
import styles from "./ImgList.module.less";

type PropsImgList = {
  values: string[];
  maxHeight?: number | string;
  imgSize?: ImageSize;
};

export const ImgList: React.FC<PropsImgList> = (props) => {
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState<boolean>(false);

  const { values, maxHeight, imgSize = "small" } = props;
  const mainFrameValue = values.length > 0 ? values[0] : null;

  React.useEffect(() => {
    setError(false);
  }, [mainFrameValue, imgSize]);

  if (!mainFrameValue) return null;
  const counter = values.length > 1 ? `+${values.length - 1}` : null;

  const onOpen: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <div className={styles.box}>
      <button
        type="button"
        className={styles.imageButton}
        onClick={onOpen}
        tabIndex={-1}
        style={{
          width: "100%",
          maxWidth: maxHeight,
          aspectRatio: "1 / 1",
        }}
      >
        <div className={styles.imageBox}>
          {error ? (
            <Tag color="red">img loading error</Tag>
          ) : (
            <img
              src={imgSrc(mainFrameValue, imgSize)}
              alt=""
              onError={() => setError(true)}
            />
          )}
        </div>

        {counter && (
          <div className={styles.counter}>
            <span>{counter}</span>
          </div>
        )}
      </button>

      {open && (
        <ImgListDetails frames={[...values]} close={() => setOpen(false)} />
      )}
    </div>
  );
};
